"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  IndentLeftAlternate: ['indent-left-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,20H13.5a1,1,0,1,0,0,2H20a1,1,0,0,0,0-2Z', 'M23,15.5H13.5a1,1,0,1,0,0,2H23a1,1,0,1,0,0-2Z', 'M13.5,13H20a1,1,0,0,0,0-2H13.5a1,1,0,0,0,0,2Z', 'M13.5,8.5H23a1,1,0,1,0,0-2H13.5a1,1,0,1,0,0,2Z', 'M13.5,4H20a1,1,0,0,0,0-2H13.5a1,1,0,0,0,0,2Z', 'M10,0A1,1,0,0,0,9,1V23a1,1,0,0,0,2,0V1A1,1,0,0,0,10,0Z', 'M3.7,8.647a.751.751,0,0,0-1.2.6v1.5a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H2.249a.25.25,0,0,1,.25.25v1.5a.748.748,0,0,0,1.2.6L7.366,12.6a.751.751,0,0,0,0-1.2Z']],
  AlignLandscape: ['align-landscape', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,0H3.5a2,2,0,0,0-2,2V14.5a1,1,0,0,0,2,0V3a1,1,0,0,1,1-1h15a1,1,0,0,1,1,1V14.5a1,1,0,0,0,2,0V2A2,2,0,0,0,20.5,0Z', 'M20.5,19H7.75a.25.25,0,0,1-.25-.25V16.5a.5.5,0,0,0-.854-.353l-3.5,3.5a.5.5,0,0,0,0,.707l3.5,3.5A.5.5,0,0,0,7.5,23.5v-2.25A.25.25,0,0,1,7.75,21H20.5a1,1,0,0,0,0-2Z', 'M9.714 6.070 A2.286 2.286 0 1 0 14.286 6.070 A2.286 2.286 0 1 0 9.714 6.070 Z', 'M9.173,13.5h5.654a.994.994,0,0,0,.962-1.284,4,4,0,0,0-7.578,0A.994.994,0,0,0,9.173,13.5Z']],
  ParagraphLeftAlignAlternate: ['paragraph-left-align-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,22H1a1,1,0,1,0,0,2H23a1,1,0,0,0,0-2Z', 'M1,18.5H19a1,1,0,0,0,0-2H1a1,1,0,1,0,0,2Z', 'M23,11H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M1,7.5H19a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z', 'M1,2H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,2Z']],
  AlignPortrait: ['align-portrait', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3.5a2,2,0,0,0-2-2H9.5a1,1,0,1,0,0,2H21a1,1,0,0,1,1,1v15a1,1,0,0,1-1,1H9.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2Z', 'M4.353,3.145a.5.5,0,0,0-.707,0l-3.5,3.5A.5.5,0,0,0,.5,7.5H2.75a.25.25,0,0,1,.25.25V20.5a1,1,0,0,0,2,0V7.748a.25.25,0,0,1,.25-.25H7.5a.5.5,0,0,0,.353-.853Z', 'M17.572,8.784A2.572,2.572,0,1,0,15,11.355,2.571,2.571,0,0,0,17.572,8.784Z', 'M11.591,17.784H18.41a1,1,0,0,0,1-1.145,4.425,4.425,0,0,0-8.808,0A1,1,0,0,0,11.591,17.784Z']],
  IndentDecrease: ['indent-decrease', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.874,1H5.374a1,1,0,1,0,0,2h17.5a1,1,0,0,0,0-2Z', 'M22.874,21H5.374a1,1,0,1,0,0,2h17.5a1,1,0,0,0,0-2Z', 'M22.874,16h-11.5a1,1,0,0,0,0,2h11.5a1,1,0,0,0,0-2Z', 'M22.874,11h-11.5a1,1,0,0,0,0,2h11.5a1,1,0,0,0,0-2Z', 'M22.874,6h-11.5a1,1,0,0,0,0,2h11.5a1,1,0,0,0,0-2Z', 'M6.375,17.5a1,1,0,0,0,1-1V7.169a1,1,0,0,0-1.665-.747L.463,11.085a1,1,0,0,0,0,1.5l5.247,4.665A1.007,1.007,0,0,0,6.375,17.5Z']],
  IndentDecrease1: ['indent-decrease-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,3H23a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z', 'M23,21H10a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,16H17a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z', 'M23,11H17a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z', 'M23,6H17a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z', 'M13,13a1,1,0,0,0,0-2H6.75a.25.25,0,0,1-.25-.25V8a1,1,0,0,0-1.664-.747l-4.5,4a1,1,0,0,0,0,1.494l4.5,4A1,1,0,0,0,5.5,17a.978.978,0,0,0,.409-.088A1,1,0,0,0,6.5,16v-2.75A.25.25,0,0,1,6.75,13Z']],
  IndentIncrease: ['indent-increase', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.626,21H1.126a1,1,0,0,0,0,2h17.5a1,1,0,0,0,0-2Z', 'M1.126,3h17.5a1,1,0,0,0,0-2H1.126a1,1,0,0,0,0,2Z', 'M1.126,8h11.5a1,1,0,0,0,0-2H1.126a1,1,0,0,0,0,2Z', 'M1.126,13h11.5a1,1,0,0,0,0-2H1.126a1,1,0,1,0,0,2Z', 'M1.126,18h11.5a1,1,0,1,0,0-2H1.126a1,1,0,0,0,0,2Z', 'M18.291,6.75a1,1,0,0,0-1.665.748v9.329a1,1,0,0,0,1.665.747l5.247-4.665a1,1,0,0,0,0-1.494Z']],
  IndentIncrease1: ['indent-increase-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14,21H1a1,1,0,0,0,0,2H14a1,1,0,1,0,0-2Z', 'M1,3H14a1,1,0,0,0,0-2H1A1,1,0,0,0,1,3Z', 'M1,8H7A1,1,0,0,0,7,6H1A1,1,0,0,0,1,8Z', 'M1,13H7a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z', 'M1,18H7a1,1,0,1,0,0-2H1a1,1,0,0,0,0,2Z', 'M23.664,11.251l-4.5-4A1,1,0,0,0,17.5,8v2.75a.25.25,0,0,1-.25.25H11a1,1,0,0,0,0,2h6.25a.25.25,0,0,1,.25.25V16a1,1,0,0,0,.591.912A.978.978,0,0,0,18.5,17a1,1,0,0,0,.664-.253l4.5-4a1,1,0,0,0,0-1.494Z']],
  IndentLeft: ['indent-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.207,8.791A1,1,0,0,0,3.5,9.5v.75a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H3.25a.25.25,0,0,1,.25.25v.75a1,1,0,0,0,.617.924,1,1,0,0,0,1.09-.217l2-2a1,1,0,0,0,0-1.414Z', 'M9,0A1,1,0,0,0,8,1V23a1,1,0,0,0,2,0V1A1,1,0,0,0,9,0Z', 'M22.5,20.5h-10a1,1,0,0,0,0,2h10a1,1,0,0,0,0-2Z', 'M12.5,2.5H23a1,1,0,0,0,0-2H12.5a1,1,0,0,0,0,2Z', 'M12.5,7.5h8a1,1,0,0,0,0-2h-8a1,1,0,0,0,0,2Z', 'M23,10.5H12.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M12.5,17.5h8a1,1,0,0,0,0-2h-8a1,1,0,0,0,0,2Z']],
  IndentRight: ['indent-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,11.5a1,1,0,0,0-1-1H20.75a.25.25,0,0,1-.25-.25V9.5a1,1,0,0,0-1.707-.707l-2,2a1,1,0,0,0,0,1.414l2,2A1,1,0,0,0,20.5,13.5v-.75a.25.25,0,0,1,.25-.25H23A1,1,0,0,0,24,11.5Z', 'M15,0a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V1A1,1,0,0,0,15,0Z', 'M10.5,20.5h-9a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z', 'M10.5.5H1a1,1,0,0,0,0,2h9.5a1,1,0,0,0,0-2Z', 'M10.5,5.5h-7a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2Z', 'M10.5,10.5H1a1,1,0,0,0,0,2h9.5a1,1,0,0,0,0-2Z', 'M10.5,15.5h-7a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2Z']],
  ParagraphBullets: ['paragraph-bullets', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.044,0H1.956A1.959,1.959,0,0,0,0,1.954V22.042A1.959,1.959,0,0,0,1.956,24H22.044A1.959,1.959,0,0,0,24,22.042V1.954A1.959,1.959,0,0,0,22.044,0ZM21,22,3,22.04a1,1,0,0,1-1-1L1.958,3a1,1,0,0,1,1-1L21,1.956a1,1,0,0,1,1,1V21A1,1,0,0,1,21,22Z', 'M11,8.248h8.5a.75.75,0,0,0,0-1.5H11a.75.75,0,0,0,0,1.5Z', 'M11,12.748h8.5a.75.75,0,0,0,0-1.5H11a.75.75,0,0,0,0,1.5Z', 'M11,17.248h5.5a.75.75,0,1,0,0-1.5H11a.75.75,0,0,0,0,1.5Z', 'M3.500 12.998 L8.375 12.998 L8.375 17.873 L3.500 17.873 Z', 'M3.500 5.623 L8.375 5.623 L8.375 10.498 L3.500 10.498 Z']],
  Paragraph: ['paragraph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5.248H7.228a6.977,6.977,0,1,0,0,13.954H9.546a.25.25,0,0,1,.25.25V22.5a1.25,1.25,0,0,0,2.5,0V3a.25.25,0,0,1,.25-.25h3.682a.25.25,0,0,1,.25.25V22.5a1.25,1.25,0,0,0,2.5,0V3a.249.249,0,0,1,.25-.25H22.5a1.25,1.25,0,0,0,0-2.5ZM9.8,11.452a.25.25,0,0,1-.25.25H7.228a4.477,4.477,0,1,1,0-8.954H9.546A.25.25,0,0,1,9.8,3Z']],
  ParagraphCenterAlign: ['paragraph-center-align', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,23.748H2a1.25,1.25,0,0,1,0-2.5H22a1.25,1.25,0,0,1,0,2.5Z', 'M22,2.748H2a1.25,1.25,0,0,1,0-2.5H22a1.25,1.25,0,0,1,0,2.5Z', 'M20,9.748H4a1.25,1.25,0,1,1,0-2.5H20a1.25,1.25,0,1,1,0,2.5Z', 'M17.5,16.748H6.5a1.25,1.25,0,1,1,0-2.5h11a1.25,1.25,0,0,1,0,2.5Z']],
  ParagraphImageRight: ['paragraph-image-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.044,0H1.956A1.959,1.959,0,0,0,0,1.954V22.042A1.959,1.959,0,0,0,1.956,24H22.044A1.959,1.959,0,0,0,24,22.042V1.954A1.959,1.959,0,0,0,22.044,0ZM21,22,3,22.04a1,1,0,0,1-1-1L1.958,3a1,1,0,0,1,1-1L21,1.956a1,1,0,0,1,1,1V21A1,1,0,0,1,21,22Z', 'M5,12.748H9.5a.75.75,0,0,0,0-1.5H5a.75.75,0,1,0,0,1.5Z', 'M5,7.747H9.5a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M5,18.247H19a.75.75,0,0,0,0-1.5H5a.75.75,0,0,0,0,1.5Z', 'M13.000 5.998 L20.000 5.998 L20.000 12.998 L13.000 12.998 Z']],
  ParagraphIndentFirstLine: ['paragraph-indent-first-line', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.366,2.9,3.7.15a.75.75,0,0,0-1.2.6v1.5a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H2.25a.25.25,0,0,1,.25.25v1.5a.749.749,0,0,0,1.2.6L7.368,4.1A.751.751,0,0,0,7.366,2.9Z', 'M23,22H7a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,17H7a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M24,13a1,1,0,0,0-1-1H7a1,1,0,0,0,0,2H23A1,1,0,0,0,24,13Z', 'M23,7H7A1,1,0,0,0,7,9H23a1,1,0,0,0,0-2Z', 'M12,4H23a1,1,0,0,0,0-2H12a1,1,0,0,0,0,2Z']],
  ParagraphIndentLastLine: ['paragraph-indent-last-line', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,21H1a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z', 'M1,3H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,3Z', 'M23,6H1A1,1,0,0,0,1,8H23a1,1,0,0,0,0-2Z', 'M20,11H1a1,1,0,0,0,0,2H20a2,2,0,0,1,0,4H17.75a.25.25,0,0,1-.25-.25V15.04a.5.5,0,0,0-.8-.4l-4,2.942a.5.5,0,0,0-.005.8l4,3.016a.5.5,0,0,0,.3.1.491.491,0,0,0,.223-.053A.5.5,0,0,0,17.5,21v-1.75a.25.25,0,0,1,.25-.25H20a4,4,0,0,0,0-8Z', 'M10,16H1a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z']],
  ParagraphRightAlign: ['paragraph-right-align', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.476,23.248H1.524a1.25,1.25,0,0,1,0-2.5H22.476a1.25,1.25,0,0,1,0,2.5Z', 'M22.476,3.248H4.38a1.25,1.25,0,1,1,0-2.5h18.1a1.25,1.25,0,0,1,0,2.5Z', 'M22.476,9.915H8.19a1.25,1.25,0,1,1,0-2.5H22.476a1.25,1.25,0,1,1,0,2.5Z', 'M22.476,16.581H5.333a1.25,1.25,0,0,1,0-2.5H22.476a1.25,1.25,0,0,1,0,2.5Z']],
  ParagraphRightToLeft: ['paragraph-right-to-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.852,8.846H9.026a.25.25,0,0,1,.25.25v7.555a1,1,0,0,0,2,0V2.248a.25.25,0,0,1,.25-.25h2.392a.25.25,0,0,1,.25.25v14.4a1,1,0,0,0,2,0V2.248a.25.25,0,0,1,.25-.25h2.663a1,1,0,0,0,0-2H6.852a4.424,4.424,0,0,0,0,8.848ZM6.852,2H9.026a.25.25,0,0,1,.25.25V6.6a.25.25,0,0,1-.25.25H6.852A2.424,2.424,0,0,1,6.852,2Z', 'M22.014,18.585H6.133a.25.25,0,0,1-.25-.25V15.672a.5.5,0,0,0-.854-.353l-3.9,3.914a.5.5,0,0,0,0,.7l3.9,3.913A.5.5,0,0,0,5.383,24a.508.508,0,0,0,.191-.038.5.5,0,0,0,.309-.462V20.835a.25.25,0,0,1,.25-.25H22.014a1,1,0,1,0,0-2Z']],
  ParagraphSpacing: ['paragraph-spacing', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.984,4.876a1,1,0,0,0,.707-1.707L4.823.3A1,1,0,0,0,3.409.3L.543,3.169A1,1,0,0,0,1.25,4.876H2.866a.25.25,0,0,1,.25.25V18.871a.25.25,0,0,1-.25.25H1.25a1,1,0,0,0-.707,1.707l2.866,2.866a1,1,0,0,0,1.414,0l2.868-2.866a1,1,0,0,0-.707-1.707H5.366a.25.25,0,0,1-.25-.25V5.126a.25.25,0,0,1,.25-.25Z', 'M15.106,3.442H22.75a1,1,0,0,0,0-2H15.106a1,1,0,1,0,0,2Z', 'M22.75,6.22H10.806a1,1,0,1,0,0,2H22.75a1,1,0,1,0,0-2Z', 'M22.75,11H10.806a1,1,0,0,0,0,2H22.75a1,1,0,0,0,0-2Z', 'M22.75,15.776H15.106a1,1,0,1,0,0,2H22.75a1,1,0,0,0,0-2Z', 'M22.75,20.553H10.806a1,1,0,0,0,0,2H22.75a1,1,0,0,0,0-2Z']],
  ParagraphLeftAlign: ['paragraph-left-align', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,23.271H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,0,1,0,2.5Z', 'M19.637,3.225H1.5a1.25,1.25,0,0,1,0-2.5H19.637a1.25,1.25,0,0,1,0,2.5Z', 'M15.818,9.907H1.5a1.25,1.25,0,0,1,0-2.5H15.818a1.25,1.25,0,1,1,0,2.5Z', 'M18.682,16.589H1.5a1.25,1.25,0,1,1,0-2.5H18.682a1.25,1.25,0,0,1,0,2.5Z']],
  ParagraphLeftToRight: ['paragraph-left-to-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.871,8.816h2.2a.245.245,0,0,1,.245.244v7.592a.98.98,0,1,0,1.959,0V2.2a.245.245,0,0,1,.245-.245h2.449a.245.245,0,0,1,.245.245V16.652a.98.98,0,1,0,1.959,0V2.2a.245.245,0,0,1,.245-.245h2.694a.98.98,0,0,0,0-1.959H5.871a4.409,4.409,0,0,0,0,8.817Zm0-6.858h2.2A.245.245,0,0,1,8.32,2.2V6.611a.245.245,0,0,1-.245.245h-2.2a2.449,2.449,0,0,1,0-4.9Z', 'M22.87,19.246l-3.9-3.919a.49.49,0,0,0-.837.346v2.694a.245.245,0,0,1-.245.244H1.967a.98.98,0,0,0,0,1.96H17.885a.245.245,0,0,1,.245.245v2.693a.49.49,0,0,0,.837.346l3.9-3.919A.489.489,0,0,0,22.87,19.246Z']],
  ParagraphNormal: ['paragraph-normal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.044,0H1.956A1.959,1.959,0,0,0,0,1.954V22.042A1.959,1.959,0,0,0,1.956,24H22.044A1.959,1.959,0,0,0,24,22.042V1.954A1.959,1.959,0,0,0,22.044,0ZM21,22,3,22.04a1,1,0,0,1-1-1L1.958,3a1,1,0,0,1,1-1L21,1.956a1,1,0,0,1,1,1V21A1,1,0,0,1,21,22Z', 'M4.5,8.5h15a1,1,0,0,0,0-2H4.5a1,1,0,1,0,0,2Z', 'M4.5,13.5h15a1,1,0,0,0,0-2H4.5a1,1,0,1,0,0,2Z', 'M4.5,18.5h6a1,1,0,0,0,0-2h-6a1,1,0,0,0,0,2Z']],
  ParagraphTwoColumn: ['paragraph-two-column', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.044,0H1.956A1.959,1.959,0,0,0,0,1.954V22.042A1.959,1.959,0,0,0,1.956,24H22.044A1.959,1.959,0,0,0,24,22.042V1.954A1.959,1.959,0,0,0,22.044,0ZM21,22,3,22.04a1,1,0,0,1-1-1L1.958,3a1,1,0,0,1,1-1L21,1.956a1,1,0,0,1,1,1V21A1,1,0,0,1,21,22Z', 'M7.5,6.248H10a.75.75,0,0,0,0-1.5H7.5a.75.75,0,0,0,0,1.5Z', 'M4.5,10.248H10a.75.75,0,0,0,0-1.5H4.5a.75.75,0,0,0,0,1.5Z', 'M4.5,14.248H10a.75.75,0,0,0,0-1.5H4.5a.75.75,0,1,0,0,1.5Z', 'M4.5,18.248H10a.75.75,0,0,0,0-1.5H4.5a.75.75,0,0,0,0,1.5Z', 'M14,6.248h5.5a.75.75,0,0,0,0-1.5H14a.75.75,0,0,0,0,1.5Z', 'M14,10.248h5.5a.75.75,0,0,0,0-1.5H14a.75.75,0,0,0,0,1.5Z', 'M14,14.248h5.5a.75.75,0,0,0,0-1.5H14a.75.75,0,0,0,0,1.5Z', 'M14,18.248h3.5a.75.75,0,0,0,0-1.5H14a.75.75,0,0,0,0,1.5Z']],
  ParagraphRightAlignAlternate: ['paragraph-right-align-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,22H1a1,1,0,1,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,16.5H4.5a1,1,0,1,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,11H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,5.5H4.5a1,1,0,1,0,0,2H23a1,1,0,0,0,0-2Z', 'M1,2H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,2Z']],
  IndentRightAlternate: ['indent-right-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.5,20H4a1,1,0,0,0,0,2h6.5a1,1,0,1,0,0-2Z', 'M11.5,16.5a1,1,0,0,0-1-1H1a1,1,0,0,0,0,2h9.5A1,1,0,0,0,11.5,16.5Z', 'M10.5,11H4a1,1,0,1,0,0,2h6.5a1,1,0,0,0,0-2Z', 'M10.5,6.5H1a1,1,0,0,0,0,2h9.5a1,1,0,0,0,0-2Z', 'M10.5,2H4A1,1,0,0,0,4,4h6.5a1,1,0,0,0,0-2Z', 'M14,0a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V1A1,1,0,0,0,14,0Z', 'M23,11H21.749a.249.249,0,0,1-.25-.25v-1.5a.751.751,0,0,0-1.2-.6L16.632,11.4a.75.75,0,0,0,0,1.2l3.666,2.75a.75.75,0,0,0,1.2-.6v-1.5a.249.249,0,0,1,.25-.25H23a1,1,0,0,0,0-2Z']],
  InsertImageTop: ['insert-image-top', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.7.647a.75.75,0,0,0-1.2.6v1.5A.25.25,0,0,1,2.25,3H1A1,1,0,1,0,1,5H2.25a.25.25,0,0,1,.25.25v1.5a.749.749,0,0,0,1.2.6L7.366,4.6a.751.751,0,0,0,0-1.2Z', 'M20,22H10a1,1,0,0,0,0,2H20a1,1,0,0,0,0-2Z', 'M23,17H10a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M10,14H20a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z', 'M9.000 -0.002 L24.000 -0.002 L24.000 7.998 L9.000 7.998 Z']],
  InsertImageBottom: ['insert-image-bottom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.7,16.649a.75.75,0,0,0-1.2.6v1.5a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H2.25a.25.25,0,0,1,.25.25v1.5a.75.75,0,0,0,1.2.6L7.366,20.6a.751.751,0,0,0,0-1.2Z', 'M10,2H20a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z', 'M10,7H23a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z', 'M10,12H20a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Z', 'M9.000 15.998 L24.000 15.998 L24.000 23.998 L9.000 23.998 Z']],
  ParagraphImageLeft: ['paragraph-image-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16,22H1a1,1,0,0,0,0,2H16a1,1,0,0,0,0-2Z', 'M23,17H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,12H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,7H13a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M13,4H23a1,1,0,0,0,0-2H13a1,1,0,1,0,0,2Z', 'M0.000 -0.002 L10.000 -0.002 L10.000 9.998 L-0.000 9.998 Z']],
  ParagraphJustifiedAlign: ['paragraph-justified-align', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.863,23.271H1.5a1.25,1.25,0,0,1,0-2.5H14.863a1.25,1.25,0,0,1,0,2.5Z', 'M22.5,3.225H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,0,1,0,2.5Z', 'M22.5,9.907H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,0,1,0,2.5Z', 'M22.5,16.588H1.5a1.25,1.25,0,0,1,0-2.5h21a1.25,1.25,0,1,1,0,2.5Z']],
  ParagraphIndent: ['paragraph-indent', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.2,8.348a1,1,0,0,0,1.4.2l3.465-2.6a1.5,1.5,0,0,0,0-2.4L3.6.948a1,1,0,0,0-1.2,1.6l2.666,2a.25.25,0,0,1,0,.4l-2.666,2A1,1,0,0,0,2.2,8.348Z', 'M23,21.248H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,16.248H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M23,11.248H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M24,7.248a1,1,0,0,0-1-1H12a1,1,0,0,0,0,2H23A1,1,0,0,0,24,7.248Z', 'M12,3.248H23a1,1,0,0,0,0-2H12a1,1,0,0,0,0,2Z']],
  ParagraphCenterAlignAlternate: ['paragraph-center-align-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,22H1a1,1,0,1,0,0,2H23a1,1,0,0,0,0-2Z', 'M19,18.5a1,1,0,0,0,0-2H4.5a1,1,0,1,0,0,2Z', 'M23,11H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M4.5,5.5a1,1,0,1,0,0,2H19a1,1,0,0,0,0-2Z', 'M1,2H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,2Z']]
};
exports["default"] = _default;